var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_799_3412)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.5 0H7.5C3.35786 0 0 3.35786 0 7.5V24.5C0 28.6421 3.35786 32 7.5 32H24.5C28.6421 32 32 28.6421 32 24.5V7.5C32 3.35786 28.6421 0 24.5 0Z",
    fill: "url(#paint0_radial_799_3412)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5 0H7.5C3.35786 0 0 3.35786 0 7.5V24.5C0 28.6421 3.35786 32 7.5 32H24.5C28.6421 32 32 28.6421 32 24.5V7.5C32 3.35786 28.6421 0 24.5 0Z",
    fill: "url(#paint1_radial_799_3412)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0011 3.5C12.6064 3.5 12.1803 3.51488 10.847 3.5755C9.51625 3.6365 8.60787 3.84712 7.81313 4.15625C6.99088 4.4755 6.2935 4.90262 5.59875 5.59762C4.90338 6.2925 4.47625 6.98987 4.156 7.81175C3.846 8.60675 3.63512 9.5155 3.57525 10.8456C3.51562 12.179 3.5 12.6053 3.5 16.0001C3.5 19.395 3.515 19.8197 3.5755 21.153C3.63675 22.4837 3.84738 23.3921 4.15625 24.1869C4.47575 25.0091 4.90288 25.7065 5.59788 26.4013C6.2925 27.0966 6.98988 27.5247 7.8115 27.844C8.60687 28.1531 9.51537 28.3637 10.8459 28.4247C12.1792 28.4854 12.605 28.5002 15.9996 28.5002C19.3948 28.5002 19.8195 28.4854 21.1528 28.4247C22.4835 28.3637 23.3929 28.1531 24.1882 27.844C25.0101 27.5247 25.7065 27.0966 26.401 26.4013C27.0964 25.7065 27.5234 25.0091 27.8438 24.1873C28.151 23.3921 28.362 22.4835 28.4245 21.1532C28.4844 19.82 28.5 19.395 28.5 16.0001C28.5 12.6053 28.4844 12.1792 28.4245 10.8459C28.362 9.51512 28.151 8.60688 27.8438 7.81213C27.5234 6.98988 27.0964 6.2925 26.401 5.59762C25.7057 4.90237 25.0104 4.47525 24.1875 4.15637C23.3906 3.84712 22.4817 3.63638 21.151 3.5755C19.8176 3.51488 19.3931 3.5 15.9972 3.5H16.0011ZM14.8798 5.75262C15.2126 5.75213 15.584 5.75262 16.0011 5.75262C19.3388 5.75262 19.7342 5.76463 21.0522 5.8245C22.271 5.88025 22.9325 6.08388 23.3731 6.255C23.9565 6.4815 24.3724 6.75238 24.8096 7.19C25.2471 7.6275 25.5179 8.04412 25.745 8.6275C25.9161 9.0675 26.12 9.729 26.1755 10.9478C26.2354 12.2655 26.2484 12.6612 26.2484 15.9972C26.2484 19.3333 26.2354 19.7291 26.1755 21.0467C26.1198 22.2655 25.9161 22.927 25.745 23.3671C25.5185 23.9505 25.2471 24.3659 24.8096 24.8031C24.3721 25.2406 23.9568 25.5114 23.3731 25.738C22.933 25.9099 22.271 26.113 21.0522 26.1688C19.7345 26.2286 19.3388 26.2416 16.0011 26.2416C12.6634 26.2416 12.2677 26.2286 10.9501 26.1688C9.73137 26.1125 9.06987 25.9089 8.62887 25.7377C8.04562 25.5111 7.62887 25.2404 7.19137 24.8029C6.75387 24.3654 6.48312 23.9498 6.256 23.3661C6.08488 22.926 5.881 22.2645 5.8255 21.0457C5.76562 19.728 5.75362 19.3323 5.75362 15.9941C5.75362 12.6561 5.76562 12.2624 5.8255 10.9446C5.88125 9.72587 6.08488 9.06437 6.256 8.62375C6.48263 8.04037 6.75388 7.62375 7.1915 7.18625C7.629 6.74875 8.04562 6.47787 8.629 6.25087C9.06962 6.079 9.73137 5.87587 10.9501 5.81987C12.1032 5.76775 12.5501 5.75212 14.8798 5.7495V5.75262ZM22.6736 7.82812C21.8455 7.82812 21.1736 8.49938 21.1736 9.32763C21.1736 10.1558 21.8455 10.8276 22.6736 10.8276C23.5018 10.8276 24.1736 10.1558 24.1736 9.32763C24.1736 8.4995 23.5018 7.82762 22.6736 7.82762V7.82812ZM16.0011 9.58075C12.4561 9.58075 9.58187 12.455 9.58187 16.0001C9.58187 19.5452 12.4561 22.4181 16.0011 22.4181C19.5462 22.4181 22.4195 19.5452 22.4195 16.0001C22.4195 12.4551 19.546 9.58075 16.0009 9.58075H16.0011ZM16.0011 11.8334C18.3022 11.8334 20.1679 13.6988 20.1679 16.0001C20.1679 18.3013 18.3022 20.1669 16.0011 20.1669C13.6999 20.1669 11.8345 18.3013 11.8345 16.0001C11.8345 13.6988 13.6999 11.8334 16.0011 11.8334Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_799_3412",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.5 34.4646) rotate(-90) scale(31.7144 29.4969)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDD55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FFDD55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FF543E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C837AB"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_799_3412",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-5.36012 2.30512) rotate(78.681) scale(14.1765 58.436)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3771C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.128,
    stopColor: "#3771C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6600FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_799_3412"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstaIcon);
export default __webpack_public_path__ + "static/media/InstaIcon.81f6b81d773b502ccc9afb19f567977a.svg";
export { ForwardRef as ReactComponent };